import { CancelRounded } from "@mui/icons-material";
import { Grid, IconButton } from "@mui/material";
import AcxHierarchySelector from "components/UI/AcxHierarchySelector/AcxHierarchySelector";
import AcxMainTextField from "components/UI/AcxMainTextField";
import AcxSelectSingle from "components/UI/Select/BaseSelectComponents/AcxSelectSingle";
import { ModelComputeFrequency, ModelComputeQuota } from "models/ModelCompute";
import { AuthStore } from "stores/AuthStore";
import { useStore } from "utils/useStore";
import { LLMClassifierBuilderStore } from "../Stores/LLMClassifierBuilderStore";
import React from "react";

const ModelComputeFrequenceOptions = [
    {
        label: "Day",
        value: ModelComputeFrequency.Daily,
    },
    {
        label: "Week",
        value: ModelComputeFrequency.Weekly,
    },
];

type VolumeControlQuotaProps = {
    quota: ModelComputeQuota;
    idx: number;
};

export function VolumeControlQuota(props: VolumeControlQuotaProps) {
    const store = useStore(LLMClassifierBuilderStore);
    const authStore = useStore(AuthStore);

    return (
        <Grid
            key={props.quota.id}
            container
            item
            columnGap={1}
            flexWrap="nowrap"
            width="100%"
            alignItems="center"
        >
            <Grid item>Run the model on up to</Grid>
            <Grid item sx={{ width: "140px" }}>
                <AcxMainTextField
                    id={`${props.quota.id}-quota`}
                    type="number"
                    fullWidth
                    value={props.quota.modelQuota}
                    onChange={(event) => {
                        const value = event.target.valueAsNumber;
                        if (isNaN(value) || value < 0) return;
                        store.updateModelComputeQuota(
                            props.idx,
                            "modelQuota",
                            value,
                        );
                    }}
                />
            </Grid>
            <Grid item>conversations in</Grid>
            <Grid item flexGrow={1}>
                <AcxHierarchySelector
                    orgId={authStore.orgStore.selectedOrganization?.id ?? ""}
                    userId={authStore._user.profile.sub}
                    displayType="input"
                    initSelectedHierarchyIds={props.quota.modelComputeStructureMembers.map(
                        (m) => m.organizationStructureMemberId,
                    )}
                    setHierarchyIds={(branchIds) => {
                        store.updateModelComputeQuota(
                            props.idx,
                            "modelComputeStructureMembers",
                            branchIds.map((id) => ({
                                organizationStructureMemberId: id,
                            })),
                        );
                    }}
                    popToLeft={false}
                    popperPlacement="bottom-end"
                    removeMinHeight
                    onSaveUpdateWithHierarchies={() => {}}
                />
            </Grid>
            <Grid item>per</Grid>
            <Grid item sx={{ width: "180px" }}>
                <AcxSelectSingle
                    id={`${props.quota.id}-frequency`}
                    options={ModelComputeFrequenceOptions}
                    defaultValue={ModelComputeFrequenceOptions.find(
                        (fOption) =>
                            fOption.value === props.quota.quotaFrequency,
                    )}
                    valueField="value"
                    labelField="label"
                    onChange={(selection) =>
                        store.updateModelComputeQuota(
                            props.idx,
                            "quotaFrequency",
                            selection.value,
                        )
                    }
                    fullWidth
                />
            </Grid>
            <Grid item>
                <IconButton
                    size="small"
                    onClick={() => store.removeModelComputeQuota(props.idx)}
                >
                    <CancelRounded fontSize="small" />
                </IconButton>
            </Grid>
        </Grid>
    );
}
